package ui.app.assign.detail.definition

import androidx.compose.animation.AnimatedContent
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import apps.App
import compose.assets.Svg
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.utils.GenId
import tools.rememberString
import ui.app.assign.detail.AppDetailScope
import ui.widget.IconicSwitch
import ui.widget.Space
import kotlin.math.roundToInt

@Composable
fun AppDetailScope.AppDefOfWwwLink(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink
) {

    if (display.isMobile) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                mainContent = {
                    UrlField(
                        nnvl = nnvl,
                        wrapper = wrapper,
                        modifier = Modifier.fillMaxWidth(),
                    )

                    Space(16.dp)
                },
                secondaryContent = {
                    ViewField(
                        wrapper = wrapper,
                        nnvl = nnvl,
                        modifier = Modifier.fillMaxWidth()
                    )
                    Space(16.dp)
                    ControlsField(
                        wrapper = wrapper,
                        nnvl = nnvl,
                        modifier = Modifier.fillMaxWidth()
                    )
                    Space(16.dp)
                    ZoomField(
                        nnvl = nnvl,
                        wrapper = wrapper,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    Space(16.dp)
                    WwwScale(
                        nnvl = nnvl,
                        wrapper = wrapper,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    Space(16.dp)
                    UrlBlockingField(
                        wrapper = wrapper,
                        nnvl = nnvl,
                        modifier = Modifier.fillMaxWidth()
                    )
                    Space(16.dp)

                })
        }
    } else {
        Row {
            Column(Modifier.weight(1F)) {
                DefaultFields(wrapper, Modifier.fillMaxWidth())
            }
            Space(16.dp)
            Column(Modifier.weight(1F)) {
                UrlField(wrapper, nnvl, Modifier.fillMaxWidth())
                Space(24.dp)
                ViewField(wrapper, nnvl, Modifier.fillMaxWidth())
                Space(24.dp)
                ControlsField(wrapper, nnvl, Modifier.fillMaxWidth())
                Space(24.dp)
                ZoomField(wrapper, nnvl, Modifier.fillMaxWidth())
                Space(24.dp)
                WwwScale(wrapper, nnvl, Modifier.fillMaxWidth())
                Space(24.dp)
                UrlBlockingField(wrapper, nnvl, Modifier.fillMaxWidth())
            }
        }
    }
}

@Suppress("UnusedReceiverParameter")
@Composable
private fun AppDetailScope.UrlField(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink,
    modifier: Modifier = Modifier.width(256.dp)
) {
    Card(modifier = modifier) {
        Column(
            Modifier.padding(horizontal = 16.dp)
                .padding(bottom = 16.dp, top = 8.dp)
        ) {
            TextField(
                readOnly = !wrapper.canEdit,
                value = nnvl.url.text,
                isError = nnvl.url.err,
                onValueChange = { nnvl.url.set(it) },
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = { Icon(Svg.Www, "") },
                label = { Text(Res.string.layer_bottom_detail__www_addr_label.rememberString()) })
        }
    }
}

@Composable
private fun AppDetailScope.ViewField(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink,
    modifier: Modifier = Modifier.width(256.dp)
) {
    CheckboxGroup(
        label = Res.string.layer_bottom_detail__www_view_settings,
        modifier = modifier
    ) {
        CheckboxRow(
            wrapper = wrapper,
            field = nnvl.keyboard,
            icon = Svg.Keyboard,
            label = Res.string.layer_bottom_detail__www_keyboard_label
        )

        CheckboxRow(
            wrapper = wrapper,
            field = nnvl.fullscreen,
            icon = Svg.Fullscreen,
            label = Res.string.layer_bottom_detail__www_fullscreen_label
        )
        CheckboxRow(
            wrapper = wrapper,
            field = nnvl.controlsPanel,
            icon = Svg.Select_group,
            label = Res.string.layer_bottom_detail__www_controls_label
        )
    }
}


@Composable
private fun AppDetailScope.ControlsField(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink,
    modifier: Modifier = Modifier.width(256.dp)
) {
    CheckboxGroup(
        label = Res.string.layer_bottom_detail__www_touch_settings,
        modifier = modifier
    ) {

        RadioRow(
            wrapper = wrapper,
            field = nnvl.touchDragMode,
            mask = App.WwwLink.TouchDragMode.SCROLL,
            label = Res.string.layer_bottom_detail__www_touch_settings_scroll
        )
        RadioRow(
            wrapper = wrapper,
            field = nnvl.touchDragMode,
            mask = App.WwwLink.TouchDragMode.DRAG,
            label = Res.string.layer_bottom_detail__www_touch_settings_drag
        )
    }
}

@Suppress("UnusedReceiverParameter")
@Composable
private fun AppDetailScope.UrlBlockingField(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink,
    modifier: Modifier = Modifier.width(256.dp)
) {
    Card(modifier = modifier) {
        Column(
            Modifier.padding(16.dp)
                .fillMaxWidth()
        ) {
            Text(Res.string.layer_bottom_detail__www_block_external_label.rememberString())
            Space(8.dp)
            Card(colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)) {
                Row(
                    Modifier
                        .fillMaxWidth()
                        .clip(CardDefaults.shape)
                        .clickable(wrapper.canEdit) { nnvl.blockOtherSites.set(!nnvl.blockOtherSites.state) }
                        .padding(8.dp)) {
                    Icon(
                        imageVector = Svg.Web,
                        contentDescription = null,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                    Space(8.dp)
                    Text(
                        text = Res.string.layer_bottom_detail__www_block_external_state_label.rememberString(),
                        modifier = Modifier
                            .weight(1F)
                            .align(Alignment.CenterVertically)
                    )
                    Space(8.dp)
                    IconicSwitch(
                        checked = nnvl.blockOtherSites.state,
                        onCheckedChange = { nnvl.blockOtherSites.set(it) },
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                }
            }
            AnimatedContent(nnvl.blockOtherSites.state) {
                if (it) {
                    Space(8.dp)

                    Column {
                        nnvl.sites.state.forEach {
                            Space(4.dp)
                            SiteEntry(wrapper, nnvl, it)
                        }
                        Space(4.dp)
                        OutlinedButton(
                            onClick = { nnvl.sites.add(App.WwwLink.EnabledSite(id = GenId.get())) },
                            modifier = Modifier.fillMaxWidth(),
                        ) {
                            Icon(Svg.Plus, null)
                            Space(8.dp)
                            Text(Res.string.layer_bottom_detail__www_block_external_add_label.rememberString())
                        }
                    }

                }
            }
        }
    }
}

@Composable
private fun SiteEntry(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink,
    item: AppDetailScope.WrapperDefinition.OfWwwLink.WrapperEnabledSite.Item
) {
    TextField(
        readOnly = !wrapper.canEdit,
        value = item.url.text,
        isError = item.url.err,
        placeholder = { Text(Res.string.layer_bottom_detail__www_block_external_add_hint.rememberString()) },
        onValueChange = { item.url.set(it) },
        modifier = Modifier.fillMaxWidth(),
        trailingIcon = {
            IconButton({ nnvl.sites.removeAll { it.key == item.key } }) {
                Icon(Svg.Close, "")
            }
        })

}

@Suppress("UnusedReceiverParameter")
@Composable
private fun AppDetailScope.ZoomField(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink,
    modifier: Modifier = Modifier.width(256.dp)
) {
    Card(modifier = modifier) {
        Column(Modifier.padding(16.dp)) {
            Text(Res.string.layer_bottom_detail__www_zoom_label.rememberString())
            Space(8.dp)
            Row(Modifier.padding(horizontal = 8.dp)) {
                Text(
                    text = nnvl.zoomDefault.state.toString(),
                    modifier = Modifier.align(Alignment.CenterVertically),
                    fontWeight = FontWeight.Bold
                )
                Space(8.dp)
                Slider(
                    enabled = wrapper.canEdit,
                    modifier = Modifier.align(Alignment.CenterVertically),
                    value = (nnvl.zoomDefault.state + 10).toFloat() / 20F,
                    valueRange = 0F..1F,
                    steps = 20,
                    onValueChange = {
                        nnvl.zoomDefault.set(((it * 20F) - 10F).roundToInt())
                    }
                )
            }
        }
    }
}

@Suppress("UnusedReceiverParameter")
@Composable
private fun AppDetailScope.WwwScale(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfWwwLink,
    modifier: Modifier = Modifier.width(256.dp)
) {
    Card(modifier = modifier) {
        Column(Modifier.padding(16.dp)) {
            Text(Res.string.layer_bottom_detail__www_scale_label.rememberString())
            Space(8.dp)
            Row(Modifier.padding(horizontal = 8.dp)) {
                Text(
                    text = "${(nnvl.pageScale.state * 100F).roundToInt()}%",
                    modifier = Modifier.align(Alignment.CenterVertically),
                    fontWeight = FontWeight.Bold
                )
                Space(8.dp)
                Slider(
                    enabled = wrapper.canEdit,
                    modifier = Modifier.align(Alignment.CenterVertically),
                    value = nnvl.pageScale.state,
                    valueRange = 0.1F..1F,
                    steps = 8,
                    onValueChange = {
                        nnvl.pageScale.set(it)
                    }
                )
            }
        }
    }
}